import React, { useRef, useState } from 'react';
import Slider from 'react-slick';
import { IImage } from '../../../../../utils/types/contentful';
import { Image } from '../../../../UI/Media/Image';
import './productMainPackImages.css';

export interface ProductMainPackImagesProps {
  images: IImage[];
}

export const ProductMainPackImages: React.FC<ProductMainPackImagesProps> = ({
  images,
  badges,
}) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const slider1 = useRef();

  const handlePaginationImageItemClick = (index) => {
    slider1.current.slickGoTo(index);
    setActiveSlide(index);
  };

  const returnPaginationImageItem = (image, index) => (
    <li
      onKeyDown={() => handlePaginationImageItemClick(index)}
      onClick={() => handlePaginationImageItemClick(index)}
      value={index}
      className={`m-3 w-10 h-10 lg:w-16 lg:h-16 flex justify-center items-center rounded-full border-2 overflow-hidden ${
        activeSlide === index
          ? 'border-gray-500 opacity-100'
          : 'border-white opacity-40 hover:opacity-70'
      } transform transition-all`}>
      <Image
        {...image}
        objectFit='cover'
        height='100%'
        width='100%'
      />
    </li>
  );

  const handlePaginationPrev = () => {
    if (activeSlide === 0) {
      slider1.current.slickGoTo(images.length - 1);
      setActiveSlide(images.length - 1);
    } else {
      slider1.current.slickGoTo(activeSlide - 1);
      setActiveSlide(activeSlide - 1);
    }
  };

  const handlePaginationNext = () => {
    if (activeSlide === images.length - 1) {
      slider1.current.slickGoTo(0);
      setActiveSlide(0);
    } else {
      slider1.current.slickGoTo(activeSlide + 1);
      setActiveSlide(activeSlide + 1);
    }
  };

  return (
    <div className='relative w-full pack-images-slider-wrapper'>
      {/* Main image slider */}
      <Slider
        adaptiveHeight
        ref={(slider) => {
          slider1.current = slider;
        }}
        slidesToShow={1}
        centerMode
        isInfinite
        centerPadding={0}
        nextArrow={<></>}
        prevArrow={<></>}
        afterChange={(index) => {
          setActiveSlide(index);
        }}>
        {images?.map((image) => (
          <div className='pack-image-slide-wrapper relative'>
            <Image
              {...image}
              height='100%'
            />
          </div>
        ))}
      </Slider>
      <div className='absolute top-6 left-5'>{badges}</div>
      {/* absolute navigation cursor */}
      <div className='absolute hidden lg:flex z-10 w-full h-full top-0 left-0'>
        <button
          className='image-pagination-right w-1/2 h-full cursor-pointer'
          onClick={handlePaginationPrev}
        />
        <button
          className='image-pagination-left w-1/2 h-full cursor-pointer'
          onClick={handlePaginationNext}
        />
      </div>
      {/* Image pagination */}
      <div className='absolute w-full overflow-scroll no-scrollbar flex justify-start bottom-0 left-0 z-10'>
        <ul className='flex relative cursor-pointer'>
          {images?.map((image, index) =>
            returnPaginationImageItem(image, index)
          )}
        </ul>
      </div>
    </div>
  );
};
